export default __webpack_public_path__ + "static/media/Dancepiration.e8297593.webp";